export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12048.618e757d.jpg";